//#region src/webhook_event.ts
var WebhookEvent = /* @__PURE__ */ function(WebhookEvent) {
	WebhookEvent["OrderSent"] = "order-sent";
	WebhookEvent["OrderUpdated"] = "order-updated";
	WebhookEvent["ThirdPartyOrderSent"] = "third-party-order-sent";
	return WebhookEvent;
}(WebhookEvent || {});
//#endregion
export { WebhookEvent };

//# sourceMappingURL=webhook_event.js.map